<div class="masonry__item" style={masonryItemStyle}>

    <slot />

</div>

<script>
    export default {
        computed: {
            masonryItemStyle: ({ area }) => {
                let styles = []
                styles.push(`grid-area: ${area};`)

                return styles.filter(Boolean).join('');
            }
        },
        data() {
            return {
                area: ''
            }
        }
    }
</script>